import type { ImportBalancesMapperT } from "../types/importBalances.types";

export const importBalancesMapper: ImportBalancesMapperT = {
  importBalancesDtoToDomain: (rawData) => ({
    importedCount: rawData?.data?.imported_count ?? 0,
  }),
};
